import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  EditOutlined,
  FileTextOutlined,
  HomeOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { getUser } from '../../utils/auth';

interface H5LayoutProps {
  children: React.ReactNode;
  onLogout: () => void;
}

const titleMap: Array<[RegExp, string]> = [
  [/^\/h5\/essay\/new/, '新建批改'],
  [/^\/h5\/history/, '批改记录'],
  [/^\/h5\/essay\/\d+\/result/, '批改报告'],
  [/^\/h5\/profile/, '我的'],
];

const getTitle = (pathname: string) => {
  const match = titleMap.find(([pattern]) => pattern.test(pathname));
  return match ? match[1] : '英语批改';
};

const getActiveKey = (pathname: string) => {
  if (pathname === '/h5') return '/h5';
  if (pathname.startsWith('/h5/essay/new')) return '/h5/essay/new';
  if (pathname.startsWith('/h5/history') || pathname.includes('/result')) return '/h5/history';
  if (pathname.startsWith('/h5/profile')) return '/h5/profile';
  return pathname;
};

const H5Layout: React.FC<H5LayoutProps> = ({ children }) => {
  const location = useLocation();
  const user = getUser();
  const activeKey = getActiveKey(location.pathname);

  return (
    <div className="h5-app">
      <header className="h5-topbar">
        <div className="h5-topbar-title">{getTitle(location.pathname)}</div>
        <Link to="/h5/profile" className="h5-topbar-user" aria-label="我的">
          <UserOutlined />
          <span>{user?.name || '同学'}</span>
        </Link>
      </header>

      <main className="h5-main">{children}</main>

      <nav className="h5-tabbar">
        <Link to="/h5" className={`h5-tabbar-item ${activeKey === '/h5' ? 'active' : ''}`}>
          <HomeOutlined />
          <span>首页</span>
        </Link>
        <Link to="/h5/essay/new" className={`h5-tabbar-item ${activeKey === '/h5/essay/new' ? 'active' : ''}`}>
          <EditOutlined />
          <span>批改</span>
        </Link>
        <Link to="/h5/history" className={`h5-tabbar-item ${activeKey === '/h5/history' ? 'active' : ''}`}>
          <FileTextOutlined />
          <span>记录</span>
        </Link>
        <Link to="/h5/profile" className={`h5-tabbar-item ${activeKey === '/h5/profile' ? 'active' : ''}`}>
          <UserOutlined />
          <span>我的</span>
        </Link>
      </nav>
    </div>
  );
};

export default H5Layout;
